import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_PORTALEFORNITORI } from '../../config/api.config';
import { BaseApiService } from '../base-api.service';
import {
  ArticoloResponse,
  Attachment,
  ContrattoDashboardResponse,
  ContrattoResponse,
  PageContrattoResponse
} from '../../interfaces/api/portalefornitori.interface';
import { HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContrattoService extends BaseApiService<typeof API_PORTALEFORNITORI.contratto> {
  protected readonly baseUrl = `${environment.backend.baseUrl_portalefornitori}`;
  protected readonly config = API_PORTALEFORNITORI.contratto;

  /**
   * Ricerca standard paginata (GET /contratto)
   */
  search(queryParams?: any): Observable<PageContrattoResponse> {
    return this.request('search', { queryParams });
  }

  /**
   * Ricerca avanzata (GET /contratto/search)
   * Restituisce dati ottimizzati per la visualizzazione in tabella
   */
  searchQuery(queryParams?: any): Observable<PageContrattoResponse> {
    return this.request('searchQuery', { queryParams });
  }

  /**
   * Recupero dettaglio per ID (GET /contratto/{id})
   */
  getById(id: string): Observable<ContrattoResponse> {
    return this.request('getById', {
      params: { id }
    });
  }

  /**
   * Effettua l'upload del contratto per un fornitore specifico.
   * @param supplierId UUID del fornitore (path parameter)
   * @param ignoreAI Forza l'update ignorando l'AI (query parameter)
   * @param payload Oggetto contenente data e file (body)
   */
  uploadContratto(supplierId: string, ignoreAI: boolean, payload: FormData): Observable<ContrattoResponse> {
    const params = new HttpParams().set('ignoreAI', ignoreAI.toString());
    let url = `${this.baseUrl}/${this.config.uploadFile.path}`;
    url = url.replace(`{supplierId}`, supplierId);
    const header = new HttpHeaders({
      'Accept': 'application/json'
    });
    return this.http.post<any>(url, payload, {
      params: params,
      headers: header
    });
  }


  update(supplierId: string, contractId: string, ignoreAI: boolean, payload: FormData): Observable<ContrattoResponse> {
    const params = new HttpParams().set('ignoreAI', ignoreAI.toString());
    let url = `${this.baseUrl}/${this.config.edit.path}`;
    url = url.replaceAll(`{supplierId}`, supplierId);
    url = url.replaceAll(`{contractId}`, contractId);
    const header = new HttpHeaders({
      'Accept': 'application/json'
    });
    return this.http.put<any>(url, payload, {
      params: params,
      headers: header
    });
  }




  getArticoliContratto(id: string): Observable<ArticoloResponse[]> {
    return this.request('getArticoliContratto', {
      params: { id }
    });
  }

  getStatiContratto(): Observable<string[]> {
    return this.request('getStatiContratto');
  }

  countNear(): Observable<number> {
    return this.request('countNear');
  }

  countNearList(): Observable<ContrattoDashboardResponse[]> {
    return this.request('countNearList');
  }

  download(id: string): Observable<Blob> {
    let url = `${this.baseUrl}/${this.config.download.path}`;
    url = url.replace(`{id}`, id);
    return this.http.get(url, {
      responseType: 'blob',
      headers: { 'Accept': 'application/octet-stream' }
    });
  }

  get searchContratto() {
    return this.searchQuery.bind(this);
  }



  uploadFileAttachment(id: string, payload: FormData): Observable<Attachment> {
    let url = `${this.baseUrl}/${this.config.uploadFileAttachment.path}`;
    url = url.replace(`{id}`, id);
    return this.http.post<any>(url, payload);
  }

  dowloadFileAttachment(id: string, attachmentId: string): Observable<Blob> {
    let url = `${this.baseUrl}/${this.config.dowloadFileAttachment.path}`;
    url = url.replace(`{id}`, id);
    url = url.replace(`{attachmentId}`, attachmentId);
    return this.http.get(url, {
      responseType: 'blob',
      headers: { 'Accept': 'application/octet-stream' }
    });
  }

  deleteFileAttachment(id: string, attachmentId: string): Observable<void> {
    return this.request('deleteFileAttachment', { params: { id, attachmentId } });
  }



}